/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import screenshot1 from "assets/images/SippenSause/screenshot.jpg";
import screenshot2 from "assets/images/SippenSause/screenshot2.jpg";
import screenshot3 from "assets/images/SippenSause/screenshot3.jpg";
import screenshot4 from "assets/images/SippenSause/screenshot4.jpg";
import screenshot5 from "assets/images/SippenSause/screenshot5.jpg";
import screenshot6 from "assets/images/SippenSause/screenshot6.jpg";
import screenshot7 from "assets/images/SippenSause/screenshot7.jpg";
import screenshot8 from "assets/images/SippenSause/screenshot8.jpg";
import screenshot9 from "assets/images/SippenSause/screenshot9.jpg";

function SippenSauseImageGallery() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <MKTypography
          height="150px"
          variant="h3"
          fontWeight="bold"
          textAlign="center"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Screenshots of the Game
        </MKTypography>
        <Grid
          container
          spacing={1}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {[
            screenshot1,
            screenshot2,
            screenshot3,
            screenshot4,
            screenshot5,
            screenshot6,
            screenshot7,
            screenshot8,
            screenshot9,
          ].map((screenshot, index) => (
            <Grid item xs={12} sm={4} lg={1} key={index}>
              <MKBox
                component="img"
                src={screenshot}
                alt={`SippenSause Screenshot ${index + 1}`}
                width="100%"
                height="auto"
                onClick={() => {
                  // Create modal overlay
                  const modal = document.createElement("div");
                  modal.style.position = "fixed";
                  modal.style.top = "0";
                  modal.style.left = "0";
                  modal.style.width = "100%";
                  modal.style.height = "100%";
                  modal.style.backgroundColor = "rgba(0,0,0,0.9)";
                  modal.style.display = "flex";
                  modal.style.justifyContent = "center";
                  modal.style.alignItems = "center";
                  modal.style.zIndex = "1000";

                  // Create image element
                  const modalImg = document.createElement("img");
                  modalImg.src = screenshot;
                  modalImg.style.maxHeight = "90vh";
                  modalImg.style.maxWidth = "90vw";
                  modalImg.style.objectFit = "contain";

                  // Add navigation buttons
                  const prevBtn = document.createElement("button");
                  prevBtn.innerHTML = "❮";
                  prevBtn.style.position = "fixed";
                  prevBtn.style.left = "5%";
                  prevBtn.style.fontSize = "30px";
                  prevBtn.style.color = "white";
                  prevBtn.style.background = "none";
                  prevBtn.style.border = "none";
                  prevBtn.style.cursor = "pointer";

                  const nextBtn = document.createElement("button");
                  nextBtn.innerHTML = "❯";
                  nextBtn.style.position = "fixed";
                  nextBtn.style.right = "5%";
                  nextBtn.style.fontSize = "30px";
                  nextBtn.style.color = "white";
                  nextBtn.style.background = "none";
                  nextBtn.style.border = "none";
                  nextBtn.style.cursor = "pointer";

                  // Navigation functionality
                  const screenshots = [
                    screenshot1,
                    screenshot2,
                    screenshot3,
                    screenshot4,
                    screenshot5,
                    screenshot6,
                    screenshot7,
                    screenshot8,
                    screenshot9,
                  ];
                  let currentIndex = index;

                  prevBtn.onclick = (e) => {
                    e.stopPropagation();
                    currentIndex = (currentIndex - 1 + screenshots.length) % screenshots.length;
                    modalImg.src = screenshots[currentIndex];
                  };

                  nextBtn.onclick = (e) => {
                    e.stopPropagation();
                    currentIndex = (currentIndex + 1) % screenshots.length;
                    modalImg.src = screenshots[currentIndex];
                  };

                  // Close on click outside image
                  modal.onclick = () => {
                    document.body.removeChild(modal);
                  };

                  modalImg.onclick = (e) => {
                    e.stopPropagation();
                  };

                  modal.appendChild(modalImg);
                  modal.appendChild(prevBtn);
                  modal.appendChild(nextBtn);
                  document.body.appendChild(modal);
                }}
                sx={{
                  borderRadius: "12px",
                  boxShadow: 3,
                  transition: "transform 0.3s",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default SippenSauseImageGallery;
